import { Injectable } from "@angular/core";
import { AppConfig } from "../shared/constants/app.config";
import { Observable, throwError } from "rxjs";
import { HttpClient, HttpResponse } from "@angular/common/http";


@Injectable()
export class FhirService {
  constructor(private readonly http: HttpClient,
    ) { }

  lookupPatientIdentifier(identifier): Observable<any> {
    const fhirGetUrl =
      localStorage.getItem("cibmtr_url") + "Patient?identifier=".concat(identifier);
    return this.http.get(fhirGetUrl);
  }

  // This method is only called on a launch from R4 ehr with STU3 registered patient
  lookupPatientIdentifierSTU3(identifier): Observable<any> {
    return this.http.get(AppConfig.CIBMTR_FHIR_R3_URL + "Patient?identifier=".concat(identifier.replace(/r4/i, "STU3")))
  }

  getCrid(payload): Observable<any> {
    const cridUrl = `${localStorage.getItem("cibmtr_url")}Patient/$crid-assignment`;
    return this.http.post(cridUrl, payload);
  }
  // Create EHR Patient in Cibmtr FHIR Server
  submitPatient(createEhrPatient) {
    const fhirPostUrl = `${localStorage.getItem("cibmtr_url")}Patient`;
    return this.http.post<HttpResponse<any>>(fhirPostUrl, createEhrPatient, { observe: 'response' });
  }

  // Update EHR Patient in Cibmtr FHIR Server
  updatePatient(updatedEhrPatient, logicalId) {
    const fhirUpdateUrl = `${localStorage.getItem("cibmtr_url")}Patient/${logicalId}`;
    return this.http.put<HttpResponse<any>>(fhirUpdateUrl, updatedEhrPatient, { observe: 'response' });
  }

  submitAuditEvent(payload: any): Observable<any> {
    const fhirPostUrl = `${localStorage.getItem("cibmtr_url")}Bundle`;
    return this.http.post<HttpResponse<any>>(fhirPostUrl, payload, { observe: 'response' });
  }

  handleError(error: any): Observable<any> {
    if (error != null) {
      console.error("An error occurred" + error);
      return throwError(error.message || error);
    } else {
      console.error("An unknown error occurred");
      return throwError("Unknown error");
    }
  }
}
